import { IMPORT_DESCRIPTOR_SOURCE } from '../../../../../../constants/generalConstants';
import { ImportTableDescriptorType, ImportDescriptorIdType } from '../../../../../../types';

type GetImportTableRowStylingReturnType = {
    styles: Record<string, string>;
    classes: string;
};

export function getImportTableRowStyling(
    descriptor: ImportTableDescriptorType,
    highlightedVariables: ImportDescriptorIdType[]
): GetImportTableRowStylingReturnType {
    const styles: Record<string, string> = {};

    if (descriptor.style?.backgroundColor) {
        styles['--custom-bg'] = descriptor.style.backgroundColor;
    }

    let classes = '';
    if (styles['--custom-bg']) {
        classes = `${classes} custom-background`;
    }
    if (descriptor.source === IMPORT_DESCRIPTOR_SOURCE.MASTER_TABLE) {
        classes = `${classes} master-table__text`;
    }
    if (highlightedVariables.includes(descriptor.id)) {
        classes = `${classes} descriptor--highlighted`;
    }
    return { styles, classes };
}
